import { Box, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";

const PolicyText = styled(Box)(({ theme }) => ({
  lineHeight: "1.8",
  marginBottom: theme.spacing(2),
  textAlign: "left"
}));

const PolicySectionTitle = styled(Box)(({ theme }) => ({
  fontWeight: "bold",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
  color: "var(--red-primary)"
}));

const PolicyListItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1)
}));

const RefundPolicy = () => {
  const navigate = useNavigate();

  const buildPolicySection = (title: string, items: string[]) => (
    <>
      <PolicySectionTitle className="B-16">{title}</PolicySectionTitle>
      {items.map((item, index) => (
        <PolicyListItem key={index} className="B-14">
          • {item}
        </PolicyListItem>
      ))}
    </>
  );

  return (
    <section style={{ backgroundColor: "var(--bg-color)", minHeight: "100vh", padding: "50px 0" }}>
      <Container>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <h1 className="H-32" style={{ color: "var(--red-primary)" }}>
            İPTAL VE İADE ŞARTLARI
          </h1>
        </Box>

        <Box sx={{ 
          backgroundColor: "white", 
          padding: 4, 
          borderRadius: "16px", 
          boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.1)" 
        }}>
          <PolicyText className="B-14">
            <Box sx={{ textAlign: "center", mb: 2, fontStyle: "italic", color: "var(--gray-primary)" }}>
              Yürürlük Tarihi: 06/10/2025<br />
              Son Güncelleme: 06/10/2025
            </Box>

            {buildPolicySection('GENEL ESASLAR', [
              'Tüm ödemeler dernek üyeliği kapsamında yapılır ve Dernekler Kanunu\'na tabidir.',
              'Ödemeler, üyelerin uygulama üzerinden aidat ve yıllık aidat yükümlülüklerini yerine getirmesi amacıyla alınır.',
              'Ödeme işlemleri, Dernek tarafından belirlenen ödeme altyapısı veya bankacılık sistemleri üzerinden güvenli biçimde gerçekleştirilir.',
            ])}

            {buildPolicySection('İADE EDİLEBİLEN İŞLEMLER', [
              'Yıllık aidat tutarından fazla ödeme yapılması durumunda, fazla tutar kullanıcıya iade edilir.',
              'Yanlışlıkla yapılan ödemeler (örneğin aynı aidatın birden fazla kez ödenmesi, sistemsel veya kullanıcı hatası kaynaklı mükerrer işlemler) kullanıcı talebi üzerine iade edilir.',
              'Bu durumlarda kullanıcı, iade talebini info@besiktaslitibbiyeliler.org adresine yazılı olarak iletmelidir.',
              'İade işlemleri, talebin alınmasından sonra en geç 15 (on beş) iş günü içinde, ödemenin yapıldığı aynı yöntemle gerçekleştirilir.',
            ])}

            {buildPolicySection('İADE EDİLMEYEN İŞLEMLER', [
              'Dernek üyeliği kapsamında yapılan aidat ödemeleri, üyelik hizmetinin bir parçası olduğundan iade edilmez.',
              'Aidat veya yıllık aidat ödendikten sonra, üyeliğin sonlandırılması veya istifa edilmesi durumunda da geçmiş ödemeler geri ödenmez.',
              'Etkinlik veya bağış niteliğindeki özel katkı ödemeleri, hizmetin sunulmuş olması nedeniyle iade edilmez.',
            ])}

            {buildPolicySection('İLETİŞİM', [
              'Beşiktaşlı Tıbbiyeliler Derneği',
              '📍 Adres: Metropol İstanbul, Atatürk, Ertuğrul Gazi Sk. No:2E A2 Blok D:452, 34758 Ataşehir/İstanbul',
              '📧 E-posta: info@besiktaslitibbiyeliler.org',
              '📞 Telefon: +90 506 199 95 12',
              '🌐 Web Sitesi: https://besiktaslitibbiyeliler.org',
            ])}

            <Box sx={{ mt: 3, p: 2, backgroundColor: "var(--bg-light)", borderRadius: "8px" }}>
              <PolicyText className="B-14" sx={{ fontStyle: "italic", color: "var(--gray-primary)" }}>
                Beşiktaşlı Tıbbiyeliler Derneği, üyelerimizin güvenine layık olabilmek için ödeme süreçlerinde adil, şeffaf ve mevzuata uygun şekilde hareket etmeyi taahhüt eder.
              </PolicyText>
            </Box>
          </PolicyText>

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button 
              variant="contained" 
              onClick={() => navigate(-1)}
              sx={{ 
                backgroundColor: "var(--red-primary)",
                "&:hover": {
                  backgroundColor: "var(--red-dark)"
                }
              }}
            >
              Geri Dön
            </Button>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default RefundPolicy;
